import { render, staticRenderFns } from "./kanrenOrder.vue?vue&type=template&id=67b7c0a5&"
import script from "./kanrenOrder.vue?vue&type=script&lang=js&"
export * from "./kanrenOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports